
type CompactTier = {
  /** Threshold at which this suffix kicks in. */
  value: number;
  /** Suffix appended to the scaled number. */
  suffix: string;
  /** Maximum decimal places retained after scaling. */
  maxFractionDigits: number;
};

const TIERS: readonly CompactTier[] = [
  { value: 10_000_000, suffix: 'Cr', maxFractionDigits: 2 },
  { value: 100_000, suffix: 'L', maxFractionDigits: 1 },
  { value: 1_000, suffix: 'K', maxFractionDigits: 1 },
];

export type FormatCompactAmountOptions = {
  prefix?: string;
  roundDown?: boolean;
};

const ROUND_DOWN_FRACTION_DIGITS = 2;

export const formatCompactAmount = (
  amount: number,
  opts: FormatCompactAmountOptions = {},
): string => {
  const { prefix = '', roundDown = false } = opts;

  for (const tier of TIERS) {
    if (amount >= tier.value) {
      const scaled = amount / tier.value;
      let formatted: string;
      if (Number.isInteger(scaled)) {
        formatted = String(scaled);
      } else if (roundDown) {
        const factor = 10 ** ROUND_DOWN_FRACTION_DIGITS;
        const truncated = Math.floor(scaled * factor) / factor;
        // Keep exactly 2 decimals for non-whole values — no trailing-zero trim.
        formatted = truncated.toFixed(ROUND_DOWN_FRACTION_DIGITS);
      } else {
        formatted = scaled.toFixed(tier.maxFractionDigits).replace(/\.?0+$/, '');
      }
      return `${prefix}${formatted}${tier.suffix}`;
    }
  }

  return `${prefix}${amount}`;
};
